const SALESFORCE_ID = /^[a-zA-Z0-9]{15}(?:[a-zA-Z0-9]{3})?$/;

export function isSalesforceId(value: unknown): value is string {
  return typeof value === 'string' && SALESFORCE_ID.test(value);
}

export function recordKey(id: string): string {
  return id.slice(0, 15);
}

export function soqlString(value: string): string {
  return `'${value.replace(/\\/g, '\\\\').replace(/'/g, "\\'")}'`;
}

export function soqlStartsWith(value: string): string {
  const escaped = value
    .replace(/\\/g, '\\\\')
    .replace(/'/g, "\\'")
    .replace(/[%_]/g, '\\$&');
  return `'${escaped}%'`;
}
